/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

//  Phaser.Physics.Arcade.Body.Components

module.exports = {

    Acceleration: require('./Acceleration'),
    Angular: require('./Angular'),
    Bounce: require('./Bounce'),
    Debug: require('./Debug'),
    Drag: require('./Drag'),
    Enable: require('./Enable'),
    Friction: require('./Friction'),
    Gravity: require('./Gravity'),
    Immovable: require('./Immovable'),
    Mass: require('./Mass'),
    Size: require('./Size'),
    Velocity: require('./Velocity')

};



//////////////////
// WEBPACK FOOTER
// ./physics/arcade/components/index.js
// module id = 340
// module chunks = 0